import { useState, useEffect } from "react";
import { useTheme } from "@/components/themeProvider";
import { motion } from "framer-motion";

export function ProgressCalendar() {
  const [imageSrc, setImageSrc] = useState("/home/agenda_light.webp");
  const { theme } = useTheme();
  const isDark = theme === "dark";

  useEffect(() => {
    // Set image source based on theme
    setImageSrc(isDark ? "/home/agenda_dark.webp" : "/home/agenda_light.webp");
  }, [isDark]);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0, duration: 0.8, ease: "easeOut" }}
      className="w-full max-h-[450px] overflow-hidden select-none h-full flex flex-col bg-gradient-to-br from-blue-100 to-cyan-100 dark:from-blue-900/40 dark:to-cyan-900/40"
    >
      <motion.div
        whileTap={{ scale: 1.1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="flex justify-center"
      >
        <img
          src={imageSrc}
          alt="ProgressMade.ai calendar view showing health routines and daily activities"
          className="object-contain w-full max-h-[880px] mt-6 pointer-events-none"
          loading="lazy"
        />
      </motion.div>
    </motion.div>
  );
}
